import { IIconProps } from "./types"

export default function IconVec7(props: IIconProps) {
  const width = props.size || props.width || 34
  const height = props.size || props.height || 22
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 34 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.2292 16.3378C21.9563 16.1385 17.6675 15.9424 13.306 15.2498C8.9318 14.5571 4.45958 13.3837 2.23611 12.7922C2.26222e-06 12.1976 0 12.1977 0 12.1977L0.679994 7.88672L26.9092 12.0237L26.2292 16.3378Z"
        fill="#3A3939"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 1.46155C4.81092 0.980799 9.12189 0.5 13.5941 0.5C18.079 0.5 22.7252 0.980783 25.0467 1.22748C27.384 1.46153 27.3839 1.46155 27.3839 1.46155V5.93378H0.5V1.46155Z"
        fill="#CCCCCC"
      />
      <path
        d="M30.6079 17.942C31.84 15.7346 31.7882 13.1043 30.5 11.0566"
        stroke="#3A3939"
        stroke-width="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.587 18.1193L33.2316 18.9702L28.8954 21.5289L28.5 16.5L30.1415 17.3635L31.587 18.1193Z"
        fill="#3A3939"
      />
    </svg>
  )
}
